/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

// Scripts
import 'sections/header/header';
import 'sections/footer/footer';
import 'sections/page-hero/page-hero';
var selectors = {
  recoverPasswordForm: '#RecoverPassword',
  hideRecoverPasswordLink: '#HideRecoverPasswordLink'
};
function onShowHidePasswordForm(evt) {
  evt.preventDefault();
  toggleRecoverPasswordForm();
}
function checkUrlHash() {
  var hash = window.location.hash;

  // Allow deep linking to recover password form
  if (hash === '#recover') {
    toggleRecoverPasswordForm();
  }
}

/**
 *  Show/Hide recover password form
 */
function toggleRecoverPasswordForm() {
  var recoverPasswordForm = document.querySelector('#RecoverPasswordForm');
  var customerLoginForm = document.querySelector('#CustomerLoginForm');
  recoverPasswordForm.classList.toggle('hide');
  customerLoginForm.classList.toggle('hide');
}

/**
 *  Show reset password success message
 */
function resetPasswordSuccess() {
  var formState = document.querySelector('.reset-password-success');

  // check if reset password form was successfully submitted.
  if (!formState) {
    return;
  }

  // show success message
  var resetSuccess = document.querySelector('#ResetSuccess');
  resetSuccess.classList.remove('hide');
}
if (document.querySelector(selectors.recoverPasswordForm)) {
  checkUrlHash();
  resetPasswordSuccess();
  document.querySelector(selectors.recoverPasswordForm).addEventListener('click', onShowHidePasswordForm);
  document.querySelector(selectors.hideRecoverPasswordLink).addEventListener('click', onShowHidePasswordForm);
}